import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../stores/auth";
import { useActiveCompany } from "../stores/active-company";
import { SectionTitle, type AdminUser } from "../components/admin/shared";
import { CreateCompanyUserForm, UserTable } from "../components/admin/user-management";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsersPage,
});

function AdminUsersPage() {
  const user = useAuth((s) => s.user);
  const activeCompanyId = useActiveCompany((s) => s.activeCompanyId);
  const companyUsersQ = useQuery({
    queryKey: ["admin", "company-users", activeCompanyId],
    enabled:
      user?.role === "company_admin" ||
      (user?.role === "global_admin" && Boolean(activeCompanyId)),
    queryFn: () => api<{ users: AdminUser[] }>("/admin/company-users"),
  });
  if (!user) return null;
  const companyUsers = companyUsersQ.data?.users ?? [];
  const companyAdminCount = companyUsers.filter((u) => u.role === "company_admin").length;
  return (
    <section className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <SectionTitle icon={<Users size={18} />} title="Company users" />
        {(user.role === "company_admin" || activeCompanyId) && (
          <div className="rounded border border-border px-2 py-1 text-xs text-muted">
            Company admins: {companyAdminCount}
          </div>
        )}
      </div>
      {user.role === "global_admin" && !activeCompanyId ? (
        <div className="text-sm text-muted">Select a company to manage its users.</div>
      ) : (
        <>
          <CreateCompanyUserForm />
          <UserTable users={companyUsers} kind="company" disabled={companyUsersQ.isLoading} />
        </>
      )}
    </section>
  );
}
